import { useLayoutContext } from "../../hooks/layout-context.js";
import { jsx } from "react/jsx-runtime";
import { LAYOUT_CONTAINER_TESTID } from "@bitcart/qa";
//#region src/components/atoms/layout-container.tsx
/**
* The outermost element of an app's layout, tagged so E2E tests have a single,
* app-agnostic readiness signal to wait on.
*
* Carries no styling of its own: layouts pass whatever shell classes they need.
*/
const LayoutContainer = (props) => {
	const { isHydrated } = useLayoutContext();
	return /* @__PURE__ */ jsx("div", {
		"data-is-hydrated": isHydrated,
		"data-testid": LAYOUT_CONTAINER_TESTID,
		...props
	});
};
//#endregion
export { LayoutContainer };

//# sourceMappingURL=layout-container.js.map